/* Configurador de patitos Customima (fase 2, sustituye a Zepto) · un solo código para los 6 productos.
   Misma ficha que la de nombres (cm-personalizador): 1 color · 2 patitos (vista previa) · 3 grabados · 4 revisa y confirma.
   - La configuración de cada producto llega en CFG.base (snippet cm-patitos.liquid):
       type 'curve' → los patitos se reparten juntos a lo largo de la cadena (rolo, medida en su foto);
       type 'slots' → puntos de enganche fijos según cuántos patitos haya (eslabones y elásticos).
     colors: [{k, name, swatch, img | imgs{n}, chain, variant, price}] · S: escala real · frame: encuadre mínimo.
   - Escritorio (≥1000 px): la vista previa pasa a la primera fila de la galería (cm-deskbox), como en nombres.
   - Cesta: base + cada patito como línea propia en UNA llamada a /cart/add.js (todo o nada), unidas por _cm_grupo.
     Con «Sin cadena» (st.noBase) solo van los patitos, sueltos y sin _cm_grupo.
     El 3x2 y los códigos los calcula Shopify; cm-grupos-cesta impide quitar patitos sueltos. */
(function () {
  var root = document.querySelector('[data-cm-pat]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
  var BASE = CFG.base;
  // Montaje (pulsera elástica, oct-2026): «Colgando» = colgantes con anilla; «Sin colgar» = charms enhebrados en el elástico
  var MOUNT = BASE.mount || null;
  // Mezcla (13-oct-2026, piloto): fotos reales arriba, familias más vendidas con el 3x2, hoja de nombres con el grabado
  // en la foto trasera, cadena al final y caja nido. Solo en las fichas que traen BASE.mezcla (snippet).
  var MZ = BASE.mezcla || null;
  if (MZ && /[?&]mezcla=0/.test(location.search)) MZ = null;
  var ALL = CFG.ducks.slice(), ALLCATS = CFG.cats.slice();
  if (BASE.cats) {
    CFG.ducks = CFG.ducks.filter(function (d) { return BASE.cats.indexOf(d.cat) >= 0; });
    CFG.cats = CFG.cats.filter(function (c) { return BASE.cats.indexOf(c[0]) >= 0; });
    ALL = CFG.ducks.slice();
  }
  else {
    // los charms solo van en la pulsera de charms (y en la elástica «Sin colgar», ver applyMount)
    CFG.ducks = CFG.ducks.filter(function (d) { return d.cat !== 'charms'; });
    CFG.cats = CFG.cats.filter(function (c) { return c[0] !== 'charms'; });
    if (!MOUNT) ALL = CFG.ducks.slice();
  }
  CFG.max = BASE.max || CFG.max;
  var BY = {};
  ALL.forEach(function (d) { BY[d.k] = d; });
  var FORM_ID = root.getAttribute('data-form-id');
  var html = document.documentElement;
  html.classList.add('cm-pat');

  var st = window.__cmPat || (window.__cmPat = { color: BASE.colors[0].k, items: [], cat: CFG.cats[0][0], focus: -1, engrOpen: false });
  if (!BASE.colors.some(function (c) { return c.k === st.color; })) st.color = BASE.colors[0].k;
  function sinColgar() { return !!MOUNT && st.mount === 'sincolgar'; }
  function applyMount() {
    if (!MOUNT) return;
    var ch = sinColgar();
    CFG.ducks = ALL.filter(function (d) { return (d.cat === 'charms') === ch; });
    CFG.cats = ALLCATS.filter(function (c) { return (c[0] === 'charms') === ch; });
    if (!CFG.cats.some(function (c) { return c[0] === st.cat; })) st.cat = CFG.cats[0][0];
    stage && stage.classList.toggle('cmp-sincolgar', ch);
    var em = stage && stage.querySelector('[data-cmp-empty] span');
    if (em) em.textContent = ch ? 'Toca un patito y se pone en el elástico' : 'Toca un patito y se cuelga aquí';
    // sin colgar: alternativa con cadena serpiente de plata (pulsera de charms), debajo de los charms
    var alt = root.querySelector('.cmp-alt');
    if (ch && MOUNT.alt && !alt) {
      alt = document.createElement('p'); alt.className = 'cmp-alt';
      alt.innerHTML = '¿La prefieres en cadena de plata? <a href="' + esc(MOUNT.alt.url) + '">Ver pulsera serpiente (' + eur(MOUNT.alt.price).replace(',00', '') + ')</a>';
      var hint = root.querySelector('.cm-p__hint'); (hint || root.querySelector('[data-cm-msg]')).insertAdjacentElement('afterend', alt);
    }
    if (alt) alt.hidden = !ch;
  }
  if (MOUNT && !st.mount) {
    // enlace directo: ?montaje=sin-colgar o la variante «Sin colgar» (?variant=…)
    st.mount = /[?&]montaje=sin/.test(location.search) ? 'sincolgar' : (MOUNT.start || 'colgando');
  }

  var q = function (sel) { return document.querySelector(sel); };
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function color() { for (var i = 0; i < BASE.colors.length; i++) if (BASE.colors[i].k === st.color) return BASE.colors[i]; return BASE.colors[0]; }
  function basePrice() { return color().price || CFG.price; }
  function baseVariant() { return (MOUNT && MOUNT.variants && MOUNT.variants[st.mount]) || color().variant || CFG.variant; }
  function noun() { return BASE.noun || 'Collar'; }
  // «Sin cadena»: solo los patitos, como colgantes sueltos (28-sep-2026). Cadena y pulsera son «la»; elástico, «lo».
  function baseN() { return BASE.baseName || 'Cadena'; }
  function baseFem() { return /a$/i.test(baseN()); }
  function noBaseTxt() { return 'Sin ' + baseN().toLowerCase(); }
  function track(name, data) { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('customima_patitos_' + name, data || {}); } catch (e) {} }

  // ---------- Cadena rolo (type 'curve'): centro del hilo, lado izquierdo; el derecho es simétrico.
  // Las fotos plata y dorada NO son iguales: misma escala de eslabón, pero la dorada cuelga más abajo (punto bajo 868 frente a 683).
  var CHAIN = {
    W: { mirror: 1006, bottom: 683, L: [[162,0],[168,50],[178,100],[188,150],[200,200],[210,250],[223,300],[240,350],[253,400],[273,450],[293,500],[318,550],[352,600],[403,650],[503,683]] },
    Y: { mirror: 1004, bottom: 868, L: [[138,0],[142,50],[148,100],[156,150],[164,200],[172,250],[180,300],[191,350],[203,400],[214,450],[227,500],[241,550],[257,600],[277,650],[300,700],[328,750],[366,800],[425,850],[502,868]] }
  };
  var PATH, SEG, TOT, pathKey;
  function chainOf() { return CHAIN[color().chain] || CHAIN.W; }
  function usePath() {
    var key = BASE.path ? 'path' : (color().chain || 'W');
    if (pathKey === key) return;
    var c = chainOf();
    // BASE.path: recorrido completo medido en la foto (pulsera de charms); si no, media cadena reflejada
    PATH = BASE.path ? BASE.path.slice() : c.L.concat(c.L.slice(0, -1).reverse().map(function (p) { return [c.mirror - p[0], p[1]]; }));
    SEG = []; TOT = 0;
    for (var i = 1; i < PATH.length; i++) { var a = PATH[i - 1], b = PATH[i], l = Math.hypot(b[0] - a[0], b[1] - a[1]); SEG.push([a, b, TOT, l]); TOT += l; }
    pathKey = key;
  }
  // punto medio de la curva: el más bajo si hay recorrido propio (la parte delantera de la pulsera)
  function mid0() { if (!BASE.path) return TOT / 2; if (BASE.midX) { for (var i = 0; i < SEG.length; i++) if (SEG[i][1][0] >= BASE.midX) return SEG[i][2] + (BASE.midX - SEG[i][0][0]) / ((SEG[i][1][0] - SEG[i][0][0]) || 1) * SEG[i][3]; } var low = 0; for (var j = 0; j < SEG.length; j++) if (SEG[j][1][1] > SEG[low][1][1]) low = j; return SEG[low][2] + SEG[low][3]; }
  function angAt(s) { for (var j = 0; j < SEG.length; j++) { var g = SEG[j]; if (s <= g[2] + g[3] || j === SEG.length - 1) return Math.atan2(g[1][1] - g[0][1], g[1][0] - g[0][0]) * 180 / Math.PI; } return 0; }
  function at(s) { for (var j = 0; j < SEG.length; j++) { var g = SEG[j]; if (s <= g[2] + g[3]) { var t = (s - g[2]) / g[3]; return [g[0][0] + (g[1][0] - g[0][0]) * t, g[0][1] + (g[1][1] - g[0][1]) * t]; } } return PATH[PATH.length - 1]; }
  // Tamaño REAL: todas las fotos recortadas están a la misma escala (la anilla mide ~55 px en todas).
  // Cada base trae su escala S (rolo 0,38, calculada con eslabón frente a anilla en la foto real). Tamaño fijo: no cambia al añadir patitos.
  var S = BASE.S || 0.38;
  // Punto por donde pasa la cadena (dentro de la anilla) y extremos de cada foto; se mide al cargarla (por defecto, Mamá Pata)
  var GEO = {};
  // Elástico: la anilla sube un poco para que el cordón pase por dentro (medido en escala del patito)
  var HANG = (BASE.hang || 0) * S;
  // Pulsera de charms: anclaje medido en cada charm (el cordón pasa por el agujero), no se mide la anilla
  // ---------- Sin colgar (v3, 3-oct-2026, foto real de Susana): el elástico sale de la cola de cada pato y entra en un nudo.
  // Base del elástico sin nudos abajo (-sc.jpg); fila centrada: nudo · pato · nudo · pato · nudo, cada pato con el centro
  // del agujero sobre el cordón y girado como él; los nudos (recorte real, del alto de la cola) van POR DELANTE,
  // montados un poco sobre la cola y el pecho, así tapan el agujero y parece que el cordón entra en el pato.
  var KNOTS = [];
  function mountAt(x) {
    var P = MOUNT.path, i = 1;
    while (i < P.length - 1 && P[i][0] < x) i++;
    var a = P[i - 1], b = P[i], t = (x - a[0]) / (b[0] - a[0]);
    return { x: x, y: a[1] + (b[1] - a[1]) * t, a: +(Math.atan2(b[1] - a[1], b[0] - a[0]) * 180 / Math.PI).toFixed(1) };
  }
  function mountLayout(g) {
    var K = MOUNT.knot, n = g.length, KW = (K.x1 - K.x0) * K.s, OV = K.ov;
    var els = g.map(function (gg) { return { l: (gg.ax - gg.xl) * gg.s, r: (gg.xr - gg.ax) * gg.s }; });
    var total = KW + els.reduce(function (t, e) { return t + e.l + e.r; }, 0) + n * KW * (1 - 2 * OV);
    var fit = Math.min(1, MOUNT.avail / total), x = MOUNT.midX - total * fit / 2, out = [];
    KNOTS = [];
    if (!n) return out;
    var knot = function () { var p = mountAt(x + KW * fit / 2); KNOTS.push({ x: p.x, y: p.y, a: p.a, s: K.s * fit }); x += KW * fit * (1 - OV); };
    knot();
    els.forEach(function (e, i) {
      var hx = x + e.l * fit, p = mountAt(hx);
      out[i] = { x: p.x, y: p.y, cy: p.y, a: p.a, s: g[i].s * fit, g: g[i] };
      x = hx + e.r * fit - KW * fit * OV;
      knot();
    });
    return out;
  }
  function geo(k) { return (sinColgar() && MOUNT.geo[k]) || (BASE.geo && BASE.geo[k]) || GEO[k] || { ax: 445, ay: 255, l: 106, r: 216, b: 770 }; }
  function layout(n) {
    var g = st.items.map(function (it) { return geo(it.k); });
    if (sinColgar()) {
      if (MOUNT.path) return mountLayout(g);
      // v1 (la que prefiere Susana, 3-oct-2026): foto del elástico con sus nudos; charm con el agujero sobre el cordón en puntos fijos
      var ms = MOUNT.slots[n] || [];
      return g.map(function (gg, k) { var p = ms[k] || [500, 650]; return { x: p[0], y: p[1], cy: p[1], a: p[2] || 0, s: MOUNT.S, g: gg }; });
    }
    if (BASE.type === 'slots') {
      var slots = (BASE.slots && BASE.slots[n]) || [];
      return g.map(function (gg, k) { var p = slots[k] || [500, 600]; return { x: p[0], y: p[1] - HANG, cy: p[1], a: p[2] || 0, s: S, g: gg }; });
    }
    usePath();
    // Juntos, casi tocándose, centrados en el punto más bajo de la cadena
    var offs = [0];
    for (var k = 1; k < n; k++) offs.push(offs[k - 1] + (g[k - 1].r + g[k].l) * S * (BASE.gap || 0.97));
    var mid = n ? (offs[0] - g[0].l * S + offs[n - 1] + g[n - 1].r * S) / 2 : 0;
    return g.map(function (gg, k) { var sk = mid0() + offs[k] - mid, p = at(sk); return { x: p[0], y: p[1], a: BASE.rotate ? +angAt(sk).toFixed(1) : 0, s: S, g: gg }; });
  }

  // Anilla y extremos de cada foto, medidos al cargarla
  ALL.forEach(function (d) {
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c2 = document.createElement('canvas'); c2.width = c2.height = 250; var x2 = c2.getContext('2d'); x2.drawImage(im, 0, 0, 250, 250);
        var a = x2.getImageData(0, 0, 250, 250).data, top = -1, minX = 250, maxX = 0, maxY = 0, ring = [];
        for (var yy = 0; yy < 250; yy++) for (var xx = 0; xx < 250; xx++) if (a[(yy * 250 + xx) * 4 + 3] > 40) { if (top < 0) top = yy; if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy > maxY) maxY = yy; if (yy - top < 10) ring.push(xx); }
        if (top >= 0 && ring.length) {
          var ax = ring.reduce(function (p, v) { return p + v; }, 0) / ring.length * 4;
          GEO[d.k] = { ax: ax, ay: top * 4 + 24, l: ax - minX * 4, r: maxX * 4 - ax, b: maxY * 4 };
        }
      } catch (e) {}
      drawSvg(); };
    im.src = d.src;
  });

  // ---------- Escritorio: la vista previa es la primera fila de la galería (igual que nombres)
  var stage = root.querySelector('[data-cmp-stage]'), note = root.querySelector('.cm-p__note'), anchor = root.querySelector('[data-cmp-cats]');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
  var deskActive = function () { return !/[?&]cmdesk=0/.test(location.search) && !!mqDesk && mqDesk.matches; };
  function placeStage() {
    var grid = q('product-gallery .product-gallery__image-list');
    if (deskActive() && grid) {
      html.classList.add('cm-desk');
      var box = grid.querySelector(':scope > .cm-deskbox');
      document.querySelectorAll('.cm-deskbox').forEach(function (x) { if (x !== box) x.remove(); });
      if (!box) { box = document.createElement('div'); box.className = 'cm-deskbox'; }
      if (grid.firstChild !== box) grid.insertBefore(box, grid.firstChild);
      if (stage.parentNode !== box) box.appendChild(stage);
      if (note && note.parentNode !== box) box.appendChild(note);
    } else if (MZ) {
      // mezcla (móvil): la vista previa ocupa el sitio de las fotos reales en cuanto se elige el primer patito
      html.classList.remove('cm-desk');
      mzPlace();
    } else {
      html.classList.remove('cm-desk');
      if (stage.parentNode !== root) { root.insertBefore(stage, anchor); if (note) root.insertBefore(note, anchor); }
    }
  }

  function baseImg(n) {
    var c = color();
    if (sinColgar() && MOUNT.base && MOUNT.base[c.k]) return MOUNT.base[c.k];
    if (c.imgs) { var m = Math.max(1, Math.min(n, CFG.max)); return c.imgs[m] || c.imgs[1]; }
    return c.img;
  }
  function viewBox(minx, miny, maxx, maxy, minW) {
    var pad = 30, w = maxx - minx + pad * 2, hh = maxy - miny + pad * 2;
    if (w < minW) w = minW;
    if (w < hh * 2) w = hh * 2; else hh = w / 2;
    var cx = (minx + maxx) / 2, cy = (miny + maxy) / 2;
    return (cx - w / 2).toFixed(0) + ' ' + (cy - hh / 2).toFixed(0) + ' ' + w.toFixed(0) + ' ' + hh.toFixed(0);
  }
  var FRAMES = {};
  function fixedFrame() {
    // sin colgar: nada cuelga por debajo del cordón → encuadre más cerrado sobre la parte de abajo del elástico
    if (sinColgar()) return FRAMES.m || (FRAMES.m = MOUNT.path ? viewBox(170, 470, 830, 730, 0) : viewBox(150, 500, 850, 730, 0));
    var key = BASE.type === 'slots' ? 's' : (color().chain || 'W');
    if (FRAMES[key]) return FRAMES[key];
    var D = { ax: 445, ay: 255, l: 106, r: 216, b: 770 }, m = CFG.max, pts = [], minx, miny, maxx, maxy, minW;
    if (BASE.type === 'slots') {
      var fr = BASE.frame; minx = fr[0]; miny = fr[1]; maxx = fr[2]; maxy = fr[3]; minW = 0;
      for (var n = 1; n <= m; n++) ((BASE.slots && BASE.slots[n]) || []).forEach(function (p) { pts.push({ x: p[0], y: p[1] - HANG, a: p[2] || 0 }); });
    } else {
      usePath();
      if (BASE.path) { D = BASE.geo[Object.keys(BASE.geo)[0]]; D = { ax: D.ax, ay: D.ay, l: 151, r: 151, b: 620 }; var fr2 = BASE.frame; minx = fr2[0]; miny = fr2[1]; maxx = fr2[2]; maxy = fr2[3]; minW = 0; }
      else { var bot = chainOf().bottom; minx = 330; maxx = 680; miny = bot - 123; maxy = bot + 37; minW = 820; }
      var step = (D.r + D.l) * S * (BASE.gap || 0.97), mid = ((m - 1) * step + (D.r - D.l) * S) / 2;
      for (var k = 0; k < m; k++) { var sk = mid0() + k * step - mid, p = at(sk); pts.push({ x: p[0], y: p[1], a: BASE.rotate ? angAt(sk) : 0 }); }
    }
    // Si el patito va inclinado, cuenta las esquinas giradas alrededor de su anilla
    pts.forEach(function (p) {
      var r = (p.a || 0) * Math.PI / 180, c = Math.cos(r), sn = Math.sin(r);
      [[-D.l * S, -50], [D.r * S, -50], [-D.l * S, (D.b - D.ay) * S], [D.r * S, (D.b - D.ay) * S]].forEach(function (q) {
        var x = p.x + q[0] * c - q[1] * sn, y = p.y + q[0] * sn + q[1] * c;
        minx = Math.min(minx, x); maxx = Math.max(maxx, x); miny = Math.min(miny, y); maxy = Math.max(maxy, y);
      });
    });
    return (FRAMES[key] = viewBox(minx, miny, maxx, maxy, minW));
  }
  function drawSvg() {
    var svg = stage.querySelector('svg'), n = st.items.length, pos = layout(n);
    // sin cadena: la base se ve difuminada, solo como referencia de cómo quedan los patitos
    var bo = st.noBase ? ' opacity=".25"' : '';
    var h = '<rect x="-600" y="-600" width="2200" height="2200" fill="#fff"/><image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000"' + bo + '/>';
    st.items.forEach(function (it, k) {
      var d = BY[it.k], p = pos[k], s = p.s;
      var op = st.focus >= 0 && st.focus !== k ? ' opacity=".5"' : '';
      h += '<g transform="translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' + (p.a ? ' rotate(' + p.a + ')' : '') + ' translate(' + (-p.g.ax * s).toFixed(1) + ' ' + (-p.g.ay * s).toFixed(1) + ') scale(' + s + ')"' + op + ' data-i="' + k + '" style="cursor:pointer">';
      h += '<image href="' + d.src + '" width="1000" height="1000"/>';
      h += '</g>';
      // charms: la pulsera entra por el agujero → se vuelve a pintar la cadena solo dentro del agujero (mismo giro que el charm)
      var ho = BASE.holes && BASE.holes[it.k];
      if (ho) {
        var tr = 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' + (p.a ? ' rotate(' + p.a + ')' : '') + ' translate(' + (-p.g.ax * s).toFixed(1) + ' ' + (-p.g.ay * s).toFixed(1) + ') scale(' + s + ')';
        h += '<clipPath id="cmpHole' + k + '"><ellipse transform="' + tr + '" cx="' + ho.cx + '" cy="' + ho.cy + '" rx="' + (ho.rx * 1.6).toFixed(1) + '" ry="' + ho.ry + '"/></clipPath>';
        h += '<image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000" clip-path="url(#cmpHole' + k + ')" style="pointer-events:none"' + bo + '/>';
      }
    });
    // sin colgar: nudos reales POR DELANTE de los patos (tapan la boca del agujero, como en la joya); los lados del recorte se funden
    if (sinColgar() && n && MOUNT.knots) {
      var K = MOUNT.knot, kimg = MOUNT.knots[color().k];
      h += '<defs><linearGradient id="cmpKg" gradientUnits="userSpaceOnUse" x1="' + K.x0 + '" x2="' + K.x1 + '" y1="0" y2="0"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".06" stop-color="#fff"/><stop offset=".94" stop-color="#fff"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
        '<mask id="cmpKm" maskUnits="userSpaceOnUse" x="0" y="0" width="' + K.w + '" height="' + K.h + '"><rect width="' + K.w + '" height="' + K.h + '" fill="url(#cmpKg)"/></mask></defs>';
      KNOTS.forEach(function (p) {
        h += '<g transform="translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + p.a + ') scale(' + p.s.toFixed(3) + ') translate(' + (-K.ax) + ' ' + (-K.ay) + ')" style="pointer-events:none"' + bo + '><image href="' + kimg + '" width="' + K.w + '" height="' + K.h + '" mask="url(#cmpKm)"/></g>';
      });
    }
    // El cordón vuelve a pintarse por delante de la parte alta de cada anilla (solo el cordón: el blanco de la foto se vuelve transparente)
    if (BASE.cordFront && n) {
      h += '<defs><filter id="cmpCord" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -10 -10 -10 0 29"/></filter>';
      pos.forEach(function (p, k) { h += '<clipPath id="cmpCordC' + k + '"><rect x="' + (p.x - 60 * p.s).toFixed(1) + '" y="' + (p.cy - 40 * p.s).toFixed(1) + '" width="' + (120 * p.s).toFixed(1) + '" height="' + (80 * p.s).toFixed(1) + '"/></clipPath>'; });
      h += '</defs>';
      pos.forEach(function (p, k) { h += '<image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000" filter="url(#cmpCord)" clip-path="url(#cmpCordC' + k + ')" style="pointer-events:none"' + bo + '/>'; });
    }
    svg.innerHTML = h;
    stage.querySelector('[data-cmp-empty]').hidden = n > 0;
    var nb = stage.querySelector('.cmp-nobase');
    if (!nb) { nb = document.createElement('p'); nb.className = 'cmp-empty cmp-nobase'; nb.innerHTML = '<span></span>'; stage.appendChild(nb); }
    nb.hidden = !st.noBase;
    nb.firstChild.textContent = (baseFem() ? 'La ' : 'El ') + baseN().toLowerCase() + ' no se incluye';
    // Encuadre FIJO por producto y color: el que cabe con el máximo de patitos. Así la joya nunca cambia de tamaño
    // al añadir o quitar patitos (ni hace zoom sobre la base vacía).
    svg.setAttribute('viewBox', fixedFrame());
    if (MZ) mzShow();
  }

  // ---------- Paso 1: color de la cadena, la pulsera o el elástico
  function drawColor() {
    var box = q('[data-cmp-colors]');
    if (!box) return;
    if (!box.innerHTML.trim()) {
      // Montaje: dos tarjetas con foto, antes del color
      var mh = '';
      // mezcla: «Colgando / Sin colgar» se elige con los patitos (paso 1), no aquí (13-oct, Susana)
      if (MOUNT && !MZ) {
        var opt = function (k, name, sub, d) { return '<button type="button" class="cmp-mount__o" data-mount="' + k + '"><i class="cmp-mount__ph"><img src="' + (d ? d.src : '') + '" alt="" width="56" height="56"></i><span><b>' + name + '</b><small>' + sub + '</small></span></button>'; };
        mh = '<div class="cmp-card cmp-mount"><span class="cmp-card__l">¿Cómo llevas los patitos?</span><div class="cmp-mount__v" role="group" aria-label="Cómo llevas los patitos">' +
          opt('colgando', 'Colgando', 'Con movimiento', BY.mama) + opt('sincolgar', 'Sin colgar', 'Fijos al elástico', BY.chmama) + '</div></div>';
      }
      // 13-oct (Susana): en la mezcla, que se entienda que la cadena es un añadido opcional
      box.innerHTML = mh + '<div class="cmp-card"><span class="cmp-card__l">' + (MZ ? (MZ.colorTitle
        // pulsera elástica: el color de la pulsera (el elástico es la propia pulsera)
        ? esc(MZ.colorTitle) + (MZ.colorSub ? '<small>' + esc(MZ.colorSub) + '</small>' : '')
        : '<em class="cmp-card__badge">Recomendado</em>¿Añadimos la cadena? <b>+' + eur(basePrice()).replace(',00', '') + '</b><small>' + esc(BASE.chainNote || 'En plata o plata baño oro, de 40 cm + 5 cm de extensión.') + '</small>') : 'Color') + '</span><div class="cmp-card__v" role="group" aria-label="' + esc(BASE.colorLabel || 'Color') + '">' +
        BASE.colors.map(function (c) { return '<button type="button" class="cmp-sw" style="background:' + esc(c.swatch) + '" data-color="' + esc(c.k) + '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '"></button>'; }).join('') +
        '<span class="cmp-card__name" data-cmp-colorname></span>' +
        '<button type="button" class="cmp-nobase-btn" data-nobase="1">' + (MZ && !MZ.colorTitle ? 'No, ya tengo una' : esc(noBaseTxt()) + ' <small>(ya ' + (baseFem() ? 'la' : 'lo') + ' tengo)</small>') + '</button></div></div>' +
        (MZ && MZ.caja ? '<label class="cmp-caja"><img src="' + esc(MZ.caja.img) + '" alt="Caja nido amarilla con un huevo dorado dentro" width="60" height="60" loading="lazy"><span><b>' + esc(MZ.caja.name) + '</b><small>' + esc(MZ.caja.sub) + '</small></span><b class="cmp-caja__p">+' + eur(MZ.caja.price).replace(',00', '') + '</b><input type="checkbox" data-mz-caja aria-label="Añadir ' + esc(MZ.caja.name) + ' por ' + eur(MZ.caja.price) + '"></label>' : '');
    }
    var cj = box.querySelector('[data-mz-caja]'); if (cj) cj.checked = !!st.caja;
    box.querySelectorAll('[data-color]').forEach(function (x) { x.setAttribute('aria-pressed', !st.noBase && x.getAttribute('data-color') === st.color); });
    var nbb = box.querySelector('[data-nobase]'); if (nbb) nbb.setAttribute('aria-pressed', !!st.noBase);
    // con montaje, el paso 1 tiene dos preguntas (cómo y color): título general en vez de «Elige el color del elástico»
    if (MOUNT && !MZ) { var t1 = q('[data-cm-step="1"] > span:not(.cm-step__n)'); if (t1 && t1.textContent !== 'Elige tu pulsera') t1.textContent = 'Elige tu pulsera'; }
    box.querySelectorAll('[data-mount]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-mount') === st.mount); });
    box.querySelector('[data-cmp-colorname]').textContent = st.noBase ? '' : color().name;
  }

  // ---------- Paso 2: categorías y carrusel
  function drawCats() {
    var c = root.querySelector('[data-cmp-cats]');
    c.hidden = CFG.cats.length < 2;
    c.innerHTML = CFG.cats.map(function (x) { return '<button type="button" class="cmp-cat" data-cat="' + x[0] + '" aria-pressed="' + (st.cat === x[0]) + '">' + x[1] + '</button>'; }).join('');
  }
  // 14-oct-2026 (Susana): buscador de patitos y Patito Investigador (AECC) en todos los grupos
  function norm(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/-/g, ' '); }
  function showDuck(d) {
    if (st.q) { var t = norm(d.name + ' ' + d.handle + ' ' + (d.kw || '')); return st.q.split(/\s+/).every(function (w) { return t.indexOf(w) >= 0; }); }
    return d.cat === st.cat || (d.all && st.cat !== 'charms');
  }
  function searchBox() {
    if (root.querySelector('[data-cmp-q]') || !anchor) return;
    var w = document.createElement('div'); w.className = 'cmp-q';
    w.innerHTML = '<input type="search" data-cmp-q placeholder="Busca tu patito: profe, abuela, perrito…" aria-label="Buscar patito" autocomplete="off" enterkeyhint="search">';
    root.insertBefore(w, anchor);
    var inp = w.querySelector('input');
    if (st.q) inp.value = st.q;
    inp.addEventListener('input', function () {
      st.q = norm(inp.value).trim();
      anchor.classList.toggle('cmp-cats--off', !!st.q);
      drawCar(); root.querySelector('[data-cmp-car]').scrollLeft = 0; arrows();
    });
    inp.addEventListener('change', function () { if (st.q) track('buscar', { q: st.q }); });
  }
  function drawCar() {
    var full = st.items.length >= CFG.max;
    var list = CFG.ducks.filter(showDuck);
    root.querySelector('[data-cmp-car]').innerHTML = !list.length && st.q ? '<p class="cmp-q__none">No encontramos ese patito. Prueba con otra palabra o elige un grupo.</p>' : list.map(function (d) {
      var c = st.items.filter(function (it) { return it.k === d.k; }).length;
      return '<button type="button" class="cmp-duck' + (d.all ? ' cmp-duck--aecc' : '') + '" data-add="' + d.k + '"' + (full || d.off ? ' disabled' : '') + ' aria-label="Añadir ' + esc(d.name) + ', ' + eur(d.price) + '">' +
        (c ? '<span class="cmp-duck__n">' + c + '</span>' : '') + '<span class="cmp-duck__plus" aria-hidden="true">+</span>' + (d.all ? '<span class="cmp-duck__tag">Solidario</span>' : '') +
        '<img src="' + d.src + '" alt="" loading="lazy" width="80" height="66"><span class="cmp-duck__name">' + (d.all ? 'Investigador<small>100 % a la AECC</small>' : esc(d.name)) + '</span><span class="cmp-duck__p">+' + eur(d.price) + '</span></button>' +
        // 14-oct-2026 (Susana): el solidario va aparte, delante de los grupos, con su propia estética
        (d.all && !st.q ? '<span class="cmp-duck-sep" aria-hidden="true"></span>' : '');
    }).join('');
    // mezcla: las familias se repintan con los precios reales (y desaparecen si un patito se agota)
    if (MZ) drawFams();
  }

  // Flechas del carrusel: en ordenador la rueda no desliza en horizontal; se ocultan al llegar a cada extremo
  function arrows() {
    var car = root.querySelector('[data-cmp-car]'), prev = root.querySelector('[data-cmp-scroll="-1"]'), next = root.querySelector('[data-cmp-scroll="1"]');
    if (!car || !prev || !next) return;
    prev.hidden = car.scrollLeft <= 2;
    next.hidden = car.scrollLeft + car.clientWidth >= car.scrollWidth - 2;
  }
  root.querySelector('[data-cmp-car]').addEventListener('scroll', arrows, { passive: true });
  window.addEventListener('resize', arrows);

  // ---------- Paso 3: grabados
  function drawEngr() {
    var box = q('[data-cmp-engr]');
    if (!box) return;
    if (!st.items.length) { box.innerHTML = '<p class="cmp-engr__empty">Primero añade tus patitos.</p>'; return; }
    // mezcla: los nombres ya se piden en la hoja; aquí quedan a la vista para repasarlos o cambiarlos
    if (MZ) st.engrOpen = true;
    if (!st.engrOpen) {
      var hechos = st.items.filter(listo).length;
      box.innerHTML = '<button type="button" class="cmp-open" data-cmp-open aria-expanded="false"><span>Grabamos por detrás el nombre o la fecha de ' + (st.items.length > 1 ? 'cada patito' : 'tu patito') + ' (opcional)' + (hechos ? ' <small>(' + hechos + ' de ' + st.items.length + ')</small>' : '') + '</span><b>Grabar ▾</b></button>';
      return;
    }
    box.innerHTML = '<div class="cmp-engr">' + st.items.map(function (it, k) {
      var d = BY[it.k];
      return '<div class="cmp-row">' +
        '<div class="cmp-row__img"><span class="cmp-row__n">' + (k + 1) + '</span><img src="' + d.src + '" alt=""><button type="button" class="cmp-row__x" data-rm="' + k + '" aria-label="Quitar ' + esc(d.name) + '">✕</button></div>' +
        '<div class="cmp-row__in"><label for="cmp-g' + k + '">' + esc(d.name) + '</label><textarea id="cmp-g' + k + '" data-g="' + k + '" rows="2" autocomplete="off" autocapitalize="sentences" spellcheck="false" placeholder="' + (it.none ? 'Sin grabado' : 'Nombre o fecha') + '"' + (it.none ? ' disabled' : '') + '>' + (it.none ? '' : esc(it.txt || '')) + '</textarea>' +
        '<label class="cmp-none"><input type="checkbox" data-none="' + k + '"' + (it.none ? ' checked' : '') + '> Este patito sin grabado</label></div>' +
        '<div class="cmp-row__sym"><button type="button" class="cmp-sym" data-sym="♥" data-row="' + k + '" aria-label="Añadir corazón">♥</button><button type="button" class="cmp-sym" data-sym="∞" data-row="' + k + '" aria-label="Añadir infinito">∞</button></div>' +
        '</div>';
    }).join('') + '<p class="cm-p__hint">El grabado va por la parte de detrás del patito. Hasta 2 líneas de ' + CFG.maxChars + ' caracteres; ♥ y ∞ también se graban.</p></div>' +
      (st.items.length > 1 ? '<label class="cm-p__check"><input type="checkbox" data-noengrave' + (allNone() ? ' checked' : '') + '><span>Ninguno lleva grabado</span></label>' : '');
  }

  // 3x2: Shopify regala el más barato de cada 3 colgantes de la promo. Estimación para enseñar; manda la cesta.
  function promo() { var p = st.items.map(function (it) { return BY[it.k].price; }).sort(function (a, b) { return b - a; }), f = 0; for (var k = 2; k < p.length; k += 3) f += p[k]; return f; }
  function lines2(t) { return String(t || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 2); }
  // 2 líneas como máximo y maxChars por línea; mayúsculas y minúsculas tal cual las escribe la clienta
  function clean(t) { return String(t || '').split('\n').slice(0, 2).map(function (x) { return x.slice(0, CFG.maxChars); }).join('\n'); }
  function listo(it) { return !!it.none || lines2(it.txt).length > 0; }
  function allNone() { return st.items.length > 0 && st.items.every(function (it) { return it.none; }); }
  function engravedAll() { return st.items.length > 0 && st.items.every(listo); }
  function grab(it) { return it.none ? '' : lines2(it.txt).join(' / '); }

  // ---------- Pasos + paso 4: revisa y confirma (cm-sum, igual que nombres)
  // En el resumen no se dice «Plata» (parecería que solo la cadena es de plata); sí Dorado, Bicolor o el color del elástico
  function sumColor() { return st.noBase || color().name === 'Plata' ? '' : color().name; }
  function drawGuide() {
    var n = st.items.length, pats = st.items.reduce(function (s, it) { return s + BY[it.k].price; }, 0), total = (st.noBase ? 0 : basePrice()) + pats, free = promo(), final = total - free;
    // mezcla: caja nido opcional en el paso de la cadena
    var caja = MZ && MZ.caja && st.caja ? MZ.caja.price : 0;
    final += caja;
    // «Desde» = base más barata + patito más barato (igual en precio de arriba, resumen y barra fija)
    var minBase = Math.min.apply(null, BASE.colors.map(function (c) { return c.price || CFG.price; }));
    var desde = minBase + Math.min.apply(null, CFG.ducks.filter(function (d) { return !d.off; }).map(function (d) { return d.price; }));
    var totalTxt = n ? eur(final) : 'Desde ' + eur(desde);
    var set = function (num, done, active) { var s = q('[data-cm-step="' + num + '"]'); if (s) { s.classList.toggle('is-done', !!done); s.classList.toggle('is-active', !done && !!active); } };
    if (MZ) {
      // mezcla: 2 = patitos, 3 = nombres, 1 = cadena (al final), 4 = resumen
      set(2, n > 0, true);
      set(3, n > 0 && !st.run && !!st.cad, n > 0);
      set(1, false, n > 0 && !!st.cad);
      set(4, false, n > 0 && !!st.cad);
    } else {
      set(1, true);
      set(2, n > 0, true);
      // grabado opcional: con patitos, el paso 3 ya cuenta como hecho y se puede confirmar
      set(3, n > 0, n > 0);
      set(4, false, n > 0);
    }

    var box = q('[data-cm-resumen]');
    if (box) {
      var design;
      // hay algún patito vacío que la clienta no ha marcado a propósito como «sin grabado»
      var vacios = st.items.some(function (it) { return !it.none && !grab(it); });
      if (!n) design = '<button type="button" class="cm-sum__todo" data-cmp-goto="2">Falta añadir tus patitos</button>';
      else design = st.items.map(function (it) { return '<small>' + esc(BY[it.k].name) + ':</small> ' + (grab(it) ? '«' + esc(grab(it)) + '»' : 'sin grabado'); }).join('<br>') +
        (vacios ? '<br><button type="button" class="cm-sum__todo" data-cmp-goto="3">¿Quieres grabarlos? Es gratis</button>' : '');
      if (html.classList.contains('cm-desk')) {
        // escritorio: una sola línea corta para que el botón quede en la primera pantalla
        var line = !n ? '<button type="button" class="cm-sum__todo" data-cmp-goto="2">Añade patitos</button>'
          : vacios ? n + ' patito' + (n > 1 ? 's' : '') + ' · <button type="button" class="cm-sum__todo" data-cmp-goto="3">Añadir grabado (gratis)</button>'
          : n + ' patito' + (n > 1 ? 's' : '') + (allNone() ? ' sin grabado' : ' listo' + (n > 1 ? 's' : ''));
        box.innerHTML = '<div class="cm-sum cm-sum--line"><div><small>Tu diseño</small>' + line + (st.noBase ? ' · ' + esc(noBaseTxt().toLowerCase()) : '') + (sumColor() ? ' · ' + esc(sumColor()) : '') + (free ? ' · <span style="color:#2f7a4b">3x2 −' + eur(free).replace(',00', '') + '</span>' : '') + '</div><b>' + totalTxt + '</b></div>' +
          '<p class="cm-sum__free">Grabado incluido en el precio</p>';
      } else {
        box.innerHTML = '<div class="cm-sum">' +
          '<div class="cm-sum__row"><span>Tu diseño</span><strong>' + design + '</strong></div>' +
          '<div class="cm-sum__row"><span>' + esc(baseN()) + '</span><span>' + (st.noBase ? 'No incluid' + (baseFem() ? 'a' : 'o') : (sumColor() ? esc(sumColor()) + ' · ' : '') + eur(basePrice())) + '</span></div>' +
          (n ? '<div class="cm-sum__row"><span>' + n + ' patito' + (n > 1 ? 's' : '') + '</span><span>' + eur(pats) + '</span></div>' : '') +
          (free ? '<div class="cm-sum__row cm-sum__row--ok"><span>🔥 3x2 en patitos</span><span>−' + eur(free) + '</span></div>' : '') +
          (caja ? '<div class="cm-sum__row"><span>' + esc(MZ.caja.name) + '</span><span>' + eur(caja) + '</span></div>' : '') +
          '<div class="cm-sum__row cm-sum__total"><span>Total</span><strong>' + totalTxt + '</strong></div>' +
          (n % 3 === 2 ? '<p class="cm-sum__free">Añade 1 patito más y el más barato te sale gratis (3x2).</p>' : '<p class="cm-sum__free">Grabado incluido en el precio</p>') + '</div>';
      }
    }
    // precio del tema (bloque precio y barra fija). 28-sep-2026: sin patitos se enseña el precio de la base
    // (el mismo que en colección, anuncios y datos de Google) y debajo «+ patitos desde»; antes era «Desde» base + patito.
    var minDuck = Math.min.apply(null, CFG.ducks.filter(function (d) { return !d.off; }).map(function (d) { return d.price; }));
    var label = n ? eur(final) : st.noBase ? 'Patitos desde ' + eur(minDuck) : eur(basePrice());
    var sub = n || st.noBase ? '' : '+ patitos desde ' + eur(minDuck).replace(',00', '');
    // mezcla: «Desde 30 €» por patito (petición de Susana, 13-oct); la cadena aparece como opcional al final
    // 13-oct: Susana quita la línea «por patito · grabado gratis»; solo «Desde 30 €»
    // 21-oct (Susana): en las fichas de los colgantes de oro, el precio de arriba es el del colgante (MZ.pieza)
    if (MZ && !n) { label = MZ.pieza ? eur(MZ.pieza) : 'Desde ' + eur(minDuck); sub = ''; }
    // solo el precio del bloque principal (7-oct-2026, igual que en el tema publicado): no tocar los precios de «Mejora tu compra»
    var productInfo = root.closest('.product-info');
    if (productInfo) productInfo.querySelectorAll('.product-info__block-item[data-block-id="price"] sale-price').forEach(function (sp) {
      var t = sp.lastChild; if (t && t.nodeType === 3) t.nodeValue = label.replace(' €', '€');
      var list = sp.closest('price-list') || sp.parentNode, s = list.parentNode.querySelector('.cmp-price-sub');
      if (!s) { s = document.createElement('p'); s.className = 'cmp-price-sub'; list.parentNode.insertBefore(s, list.nextSibling); }
      s.textContent = sub; s.hidden = !sub;
    });
    var bar = q('product-sticky-bar');
    if (bar) {
      var chip = bar.querySelector('.cmp-sticky');
      if (!chip) { chip = document.createElement('div'); chip.className = 'cmp-sticky'; var bb = bar.querySelector('buy-buttons'); bb && bb.parentNode.insertBefore(chip, bb); }
      chip.innerHTML = '<small>' + (n ? (st.noBase ? '' : noun() + ' + ') + n + ' patito' + (n > 1 ? 's' : '') : st.noBase || MZ ? 'Patitos desde' : esc(baseN()) + ' (+ patitos desde ' + eur(minDuck).replace(',00', '') + ')') + '</small><b>' + (n ? eur(final) : st.noBase || MZ ? eur(minDuck) : eur(basePrice())) + '</b>';
      if (MZ) mzBar(bar, n);
    }
    if (MZ) {
      drawTotal();
      mzD();
      var mp = q('.cmp-mz-mprog'); if (mp) mp.innerHTML = progHtml();
    }
  }

  function openEngr(focus) {
    if (!st.items.length) return;
    if (!st.engrOpen) { st.engrOpen = true; drawEngr(); track('grabado_abierto', { n: st.items.length }); }
    if (focus) {
      var empty = [].slice.call(document.querySelectorAll('[data-cmp-engr] textarea')).filter(function (x) { return !x.value && !x.disabled; })[0];
      if (empty) setTimeout(function () { empty.focus({ preventScroll: true }); }, 400);
    }
  }
  // «Llegar» = el título del paso 3 entra en la mitad baja de la pantalla haciendo scroll, con patitos ya elegidos
  var scrolled = false;
  function engrCheck() {
    if (st.engrOpen || !st.items.length || !scrolled) return;
    var s3 = q('[data-cm-step="3"]'); if (!s3) return;
    var r = s3.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.75 && r.bottom > 0) openEngr(false);
  }
  window.addEventListener('scroll', function () { scrolled = true; engrCheck(); }, { passive: true });

  function all() { drawSvg(); drawColor(); drawCar(); drawEngr(); drawGuide(); }

  // ---------- Eventos (delegados en document: los pasos viven en bloques distintos de la ficha)
  function goto(step) {
    if (step === '2') { root.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    var s3 = q('[data-cm-step="3"]'); s3 && s3.scrollIntoView({ block: 'start', behavior: 'smooth' });
    openEngr(true);
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-mount],[data-color],[data-nobase],[data-cat],[data-cmp-scroll],[data-add],[data-rm],[data-sym],[data-i],[data-cmp-goto],[data-cmp-open]');
    if (!b) return;
    var ds = b.dataset;
    if (ds.mount) {
      if (ds.mount === st.mount) return;
      // son productos distintos (colgante / charm): al cambiar de montaje se empieza de cero
      st.mount = ds.mount; st.items = []; st.focus = -1; st.engrOpen = false;
      applyMount(); drawCats(); root.querySelector('[data-cmp-car]').scrollLeft = 0; all(); arrows();
      track('montaje', { montaje: st.mount });
    }
    else if (ds.color) { st.color = ds.color; st.noBase = false; drawColor(); drawSvg(); drawGuide(); track('color', { color: st.color }); }
    else if (ds.nobase) { st.noBase = true; drawColor(); drawSvg(); drawGuide(); track('color', { color: 'sin_cadena' }); }
    else if (ds.cat) { st.cat = ds.cat; if (st.q) { st.q = ''; var qi = root.querySelector('[data-cmp-q]'); if (qi) qi.value = ''; anchor.classList.remove('cmp-cats--off'); } drawCats(); drawCar(); root.querySelector('[data-cmp-car]').scrollLeft = 0; arrows(); }
    else if (ds.cmpScroll) { var car = root.querySelector('[data-cmp-car]'); car.scrollBy({ left: +ds.cmpScroll * car.clientWidth * 0.8, behavior: 'smooth' }); }
    else if (ds.add) {
      if (st.items.length >= CFG.max) return;
      st.items.push({ k: ds.add, txt: '' });
      root.querySelector('[data-cm-msg]').textContent = '';
      all();
      engrCheck();
      track('add', { patito: ds.add, n: st.items.length });
      // mezcla: al elegir un patito sube su hoja para grabarle el nombre
      if (MZ) mzOpen([st.items.length - 1], '');
    }
    else if (ds.rm !== undefined) {
      st.items.splice(+ds.rm, 1); st.focus = -1;
      // mezcla: tras quitar uno, en escritorio se sigue con los nombres de los que quedan; en móvil se cierra la hoja
      if (MZ && st.run) { st.run = null; if (mzSheet) mzSheet.hidden = true; html.classList.remove('cmp-sh-open'); }
      all();
      if (MZ && deskWiz()) { if (st.items.length) mzOpen(allRun(), ''); else mzD(1); }
    }
    else if (ds.sym) {
      var k = +ds.row, t = q('[data-g="' + k + '"]');
      if (!t || t.disabled) return;
      var v = t.value, p0 = t.selectionStart == null ? v.length : t.selectionStart, p1 = t.selectionEnd == null ? v.length : t.selectionEnd;
      t.value = clean(v.slice(0, p0) + ds.sym + v.slice(p1));
      t.focus(); try { t.setSelectionRange(p0 + 1, p0 + 1); } catch (e) {}
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }
    else if (ds.cmpOpen !== undefined) openEngr(true);
    else if (ds.i !== undefined && MZ) mzOpen([+ds.i], '');
    else if (ds.i !== undefined) { openEngr(false); var inp = q('[data-g="' + ds.i + '"]'); if (inp) { inp.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { inp.focus({ preventScroll: true }); }, 350); } }
    else if (ds.cmpGoto) goto(ds.cmpGoto);
  });
  document.addEventListener('mousedown', function (ev) { if (ev.target.closest && ev.target.closest('[data-sym]')) ev.preventDefault(); });
  document.addEventListener('input', function (ev) {
    var t = ev.target; if (!t.dataset || t.dataset.g === undefined) return;
    var c = clean(t.value);
    if (c !== t.value) { var pos0 = t.selectionStart; t.value = c; try { t.setSelectionRange(Math.min(pos0, c.length), Math.min(pos0, c.length)); } catch (e) {} }
    st.items[+t.dataset.g].txt = c;
    var need = q('.cmp-need'); if (need) need.remove();
    drawGuide();
  });
  document.addEventListener('change', function (ev) {
    var t = ev.target; if (!t.hasAttribute) return;
    if (t.hasAttribute('data-none')) { st.items[+t.getAttribute('data-none')].none = t.checked; }
    else if (t.hasAttribute('data-noengrave')) { st.items.forEach(function (it) { it.none = t.checked; }); }
    else return;
    var need = q('.cmp-need'); if (need) need.remove();
    drawEngr(); drawGuide();
  });
  document.addEventListener('focusin', function (ev) {
    var t = ev.target; if (!t.dataset || t.dataset.g === undefined) return;
    st.focus = +t.dataset.g; drawSvg();
  });
  document.addEventListener('focusout', function (ev) {
    if (!ev.target.dataset || ev.target.dataset.g === undefined) return;
    setTimeout(function () { var a = document.activeElement; if (!a || !a.dataset || a.dataset.g === undefined) { st.focus = -1; drawSvg(); } }, 150);
  });

  // ---------- Añadir a la cesta: interceptamos el envío del formulario del tema (botón principal y barra fija)
  function payload() {
    var grupo = 'P' + Date.now().toString(36).toUpperCase();
    var c = color();
    var vaEn = noun() + ' patitos ' + c.name.toLowerCase() + (sinColgar() ? ' sin colgar' : '');
    var g = function (it) { return it.none ? 'Sin grabado' : (lines2(it.txt).join('\n') || 'Sin grabado'); };
    // Sin cadena: colgantes sueltos, igual que desde la ficha de cada patito. Sin _cm_grupo ni «Va en»,
    // porque cm-grupos-cesta quita los patitos de un grupo que no tiene base.
    // mezcla: caja nido (va la primera del envío para que en la cesta salga la última)
    var extra = MZ && MZ.caja && st.caja ? [{ id: MZ.caja.variant, quantity: 1 }] : [];
    if (st.noBase) return extra.concat(st.items.map(function (it) { return { id: BY[it.k].variant, quantity: 1, properties: { 'Graba tu patito por detrás': g(it) } }; }).reverse());
    var baseProps = {};
    baseProps[BASE.colorKey || '¿Qué color de cadena quieres?'] = c.name;
    // para el taller: cómo se montan (colgando con anilla o charms enhebrados en el elástico)
    if (MOUNT) baseProps['¿Cómo van los patitos?'] = sinColgar() ? 'Sin colgar (charms en el elástico)' : 'Colgando';
    baseProps['¿Cuántos patitos quieres añadir?'] = String(st.items.length);
    st.items.forEach(function (it, k) { baseProps['_Patito ' + (k + 1)] = BY[it.k].name; baseProps['Grabado Patito ' + (k + 1)] = g(it); });
    baseProps._cm_grupo = grupo;
    baseProps._cm_diseno = JSON.stringify({ v: 3, color: st.color, montaje: MOUNT ? st.mount : undefined, vaEn: vaEn, items: st.items.map(function (it) { return { k: it.k, variant: BY[it.k].variant, sinGrabado: !!it.none, lineas: it.none ? [] : lines2(it.txt) }; }) });
    var items = [{ id: baseVariant(), quantity: 1, properties: baseProps }];
    st.items.forEach(function (it, k) {
      items.push({ id: BY[it.k].variant, quantity: 1, properties: { 'Graba tu patito por detrás': g(it), 'Va en': vaEn + ' · posición ' + (k + 1), _cm_grupo: grupo } });
    });
    // la cesta enseña primero lo último añadido: así sale la base arriba y los patitos 1, 2, 3 debajo
    return extra.concat(items.reverse());
  }

  var busy = false;
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    // ojo: form.id es el input name="id" (variante), no el atributo id
    if (!form || !form.getAttribute || form.getAttribute('id') !== FORM_ID) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (busy) return;
    var msg = root.querySelector('[data-cm-msg]');
    if (!st.items.length) { msg.textContent = 'Añade al menos un patito a tu ' + noun().toLowerCase() + '.'; goto('2'); track('error', { tipo: 'sin_patitos' }); return; }
    // mezcla: antes del paso 3 el botón fijo dice «Siguiente» y lleva al paso siguiente (13-oct, Susana)
    if (MZ && (st.dstep || 1) < 3) {
      if ((st.dstep || 1) === 1) mzOpen(allRun(), '');
      else toCadena();
      return;
    }
    // 28-sep-2026: el grabado es opcional; los patitos sin texto van como «Sin grabado» (ver payload)
    add(form);
  }, true);

  function add(form) {
    busy = true;
    var buttons = document.querySelectorAll('button[type="submit"][form="' + FORM_ID + '"]');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    html.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    var sections = [];
    html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var done = function () { busy = false; buttons.forEach(function (b) { b.removeAttribute('aria-busy'); }); html.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true })); };
    var fail = function (t) { done(); root.querySelector('[data-cm-msg]').textContent = t; root.scrollIntoView({ block: 'center', behavior: 'smooth' }); };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: payload(), sections: sections.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) { fail(res.j.description || res.j.message || 'No hemos podido añadirlo. Inténtalo de nuevo.'); track('error', { tipo: 'cesta', msg: res.j.description || '' }); return; }
      track('added', { n: st.items.length, color: st.noBase ? 'sin_cadena' : st.color, sin_grabado: st.items.filter(function (it) { return !grab(it); }).length, patitos: st.items.map(function (it) { return it.k; }).join(',') });
      var tv = window.themeVariables && window.themeVariables.settings;
      if (tv && (tv.cartType === 'page' || tv.pageType === 'cart')) { location.href = window.Shopify.routes.root + 'cart'; return; }
      return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        done();
        cart.sections = res.j.sections;
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.j.items || [res.j], cart: cart, onSuccessDo: null } }));
        html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: null, cart: cart } }));
      });
    }).catch(function () { fail('No hemos podido añadirlo. Revisa tu conexión e inténtalo de nuevo.'); });
  }

  // Precios y disponibilidad reales de cada colgante (por si cambian en el admin)
  ALL.forEach(function (d) {
    fetch(window.Shopify.routes.root + 'products/' + d.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) { d.off = true; drawCar(); return; }
      var v = p.variants.filter(function (x) { return x.id === d.variant; })[0];
      if (!v || !v.available) d.off = true; else if (v.price !== d.price) { d.price = v.price; drawGuide(); }
      drawCar();
    }).catch(function () {});
  });

  // Barra fija en móvil: el tema solo la enseña al pasar el botón; aquí también antes de llegar a él
  var mainBtn = null;
  function barCheck() {
    if (!mainBtn || !mainBtn.isConnected) mainBtn = q('.product-info buy-buttons button[type="submit"]');
    if (!mainBtn) return;
    var r = mainBtn.getBoundingClientRect();
    // mezcla: sin patitos la barra no aporta nada (el botón no puede añadir) y tapa las familias
    // mezcla: con patitos y antes del paso 3 el botón del panel está oculto → la barra fija («Siguiente») se ve siempre
    var wiz = MZ && st.items.length && (st.dstep || 1) < 3;
    html.classList.toggle('cmp-show-bar', !!wiz || ((r.bottom < 0 || r.top > window.innerHeight) && !(MZ && !st.items.length)));
  }
  window.addEventListener('scroll', barCheck, { passive: true });
  window.addEventListener('resize', barCheck);

  // ======================================================================================================
  // MEZCLA (13-oct-2026, piloto) · propuesta aprobada en el lienzo «Mezcla 1 + 3»
  //  - Se entra con las fotos reales; la vista previa sustituye a las fotos al elegir el primer patito
  //    (botón «Fotos reales» para volver a ellas y «Tu collar» para regresar).
  //  - Debajo del precio: aviso del 3x2 y las 3 familias más vendidas (ventas oct-2025 → oct-2026), la más vendida en medio.
  //  - Hoja de nombres: al elegir familia o patito sube una hoja con la foto trasera real y el nombre grabado
  //    mientras se escribe (misma foto, zona y letra que la ficha de cada colgante). Con familia va nombre a nombre.
  //  - Orden de pasos: 1 Patitos · 2 Nombres · 3 Cadena (opcional, con caja nido). Barra de progreso en la barra fija.
  // ======================================================================================================
  var CDN = 'https://cdn.shopify.com/s/files/1/0590/8044/2013/';
  // Fotos traseras y zona del grabado de cada patito: copiadas de cm-personalizador.js (patoDetras)
  var BACKS = {
    investigador: ['-294 127 1560 780', 'pato-investigador-detras-v2.jpg', 1791993000, 1024, 415, 772, 150, 30, '#50555c', [252, 250, 470, 640]], // 14-oct-2026 AECC
    mama: ['-157 179 1344 672', 'pato-mama-detras.jpg', 0, 0, 511, 626, 160, 33, '#6b5317'],
    // 21-oct-2026 · patitos de oro 9K (solo en el collar de oro): traseras doradas con el grabado de ejemplo borrado
    mamaoro: ['-695 40 2600 1300', 'pato-mama-oro-detras.jpg', 1792511258, 1254, 586, 889, 360, 64, '#6b5317'],
    patitooro: ['-569 70 2440 1220', 'pato-patito-oro-detras.jpg', 1792511258, 1254, 676, 907, 310, 66, '#6b5317'],
    papa: ['-310 185 1800 900', 'pato-papa-detras2.jpg', 1789665000, 1254, 619, 817, 200, 44],
    patito: ['-148 216 1296 648', 'pato-patito-detras.jpg', 0, 0, 505, 616, 125, 27],
    patita: ['-138 130 1294 647', 'pato-patita-detras.jpg', 1789730000, 1024, 513, 588, 136, 27],
    bebe: ['-148 216 1296 648', 'pato-bebe-detras.jpg', 0, 0, 495, 613, 115, 31],
    bebea: ['-95 97 1213 606', 'pato-patita-bebe-detras.jpg', 1789730000, 1024, 511, 533, 144, 28],
    adol: ['-107 165 1203 602', 'pato-patito-adolescente-detras.jpg', 1789730000, 1024, 496, 591, 112, 26],
    adola: ['-98 143 1210 605', 'pato-patita-adolescente-detras.jpg', 1789770000, 1024, 501, 569, 128, 27],
    huevo: ['-145 149 1294 647', 'pato-cascaron-detras.jpg', 1791200000, 1024, 503, 580, 128, 27, '#6b5317'],
    abuela: ['-157 159 1344 672', 'pato-abuela-detras.jpg', 0, 0, 511, 626, 150, 33],
    abuelo: ['-109 161 1290 645', 'pato-abuelo-detras.jpg', 1789730000, 1024, 522, 593, 146, 25],
    angel: ['-88 149 1152 576', 'pato-angelito-detras.jpg', 1789730000, 1024, 494, 554, 126, 26],
    perro: ['-7 195 1081 540', 'pato-perrito-detras.jpg', 1789730000, 1024, 514, 582, 110, 24],
    gato: ['-43 177 1129 565', 'pato-gato-detras.jpg', 1789730000, 1024, 527, 576, 115, 27],
    cumple: ['-39 220 1050 525', 'pato-cumple-detras.jpg', 1789665000, 1024, 467, 612, 95, 30],
    graduado: ['16 257 940 470', 'pato-graduado-detras.jpg', 1789665000, 1024, 497, 624, 135, 34],
    cupido: ['-92 154 1064 532', 'pato-cupido-detras.jpg', 1789665000, 900, 398, 563, 115, 42],
    comunion: ['-233 100 1535 768', 'pato-comunion-detras.jpg', 1789730000, 1024, 518, 638, 140, 29],
    profe: ['-109 135 1310 655', 'pato-profe-detras.jpg', 1789730000, 1024, 505, 582, 150, 28],
    pelu: ['-162 151 1294 647', 'pato-peluquera-detras.jpg', 1790000000, 1024, 492, 622, 150, 28],
    admin: ['-192 91 1403 702', 'pato-administrativa-detras.jpg', 1789730000, 1024, 462, 601, 100, 26],
    enfer: ['-206 105 1435 718', 'pato-enfermera-detras.jpg', 1789730000, 1024, 502, 621, 135, 29],
    cocina: ['-187 95 1394 697', 'pato-cocinera-detras.jpg', 1789730000, 1024, 524, 594, 124, 32],
    mamapave: ['-133 145 1302 651', 'pato-mama-pave-detras.jpg', 1790000000, 1024, 519, 612, 161, 30, '#6b5317'],
    bebepave: ['-49 184 1158 579', 'pato-bebe-pave-detras.jpg', 1789740000, 1024, 522, 596, 110, 29],
    patitopave: ['-67 220 1148 574', 'pato-patito-pave-detras.jpg', 1789740000, 1024, 515, 622, 123, 25],
    // charms «Sin colgar» (13-oct-2026, Susana): trasera = foto real volteada con el corazón borrado (gpt-image, solo dentro
    // de la máscara; personalizador/patitos/sin-colgar/traseras). El charm no tiene anilla → encuadre propio (10.º valor)
    chmama: ['', 'pato-chmama-detras.jpg', 1791950000, 1024, 542, 655, 250, 58, '#6b5317', [112, 152, 792, 720]],
    chpatito: ['', 'pato-chpatito-detras.jpg', 1791950000, 1024, 534, 618, 180, 44, 0, [222, 254, 574, 518]],
    chchupete: ['', 'pato-chchupete-detras.jpg', 1791950000, 1024, 510, 633, 165, 41, 0, [187, 227, 648, 570]],
    chlazito: ['', 'pato-chlazito-detras.jpg', 1791950000, 1024, 494, 680, 160, 40, 0, [225, 195, 571, 636]],
    chchulazo: ['', 'pato-chchulazo-detras.jpg', 1791950000, 1024, 514, 676, 160, 40, 0, [193, 190, 635, 648]]
  };
  var mzBox = null, mzBack = null, mzSheet = null;
  // títulos de los 3 pasos: iguales en la barra de progreso y en el panel (13-oct, Susana)
  var MZ_TIT = ['Elige tus patitos', 'Grábalos gratis', 'Finaliza tu compra'];
  // índices del patito que sale gratis con el 3x2 (el más barato de cada 3, igual que promo())
  function freeIdx() {
    var a = st.items.map(function (it, k) { return { k: k, p: BY[it.k].price }; }).sort(function (x, y) { return y.p - x.p || x.k - y.k; }), out = {};
    for (var i = 2; i < a.length; i += 3) out[a[i].k] = 1;
    return out;
  }
  function famPrice(keys) {
    var p = keys.map(function (k) { return BY[k].price; }).sort(function (a, b) { return b - a; }), t = 0, f = 0;
    p.forEach(function (v, i) { t += v; if (i % 3 === 2) f += v; });
    // pulsera elástica (famBase): las tarjetas son pulseras completas → el precio incluye la pulsera
    if (MZ && MZ.famBase) { var b = CFG.price || 0; t += b; return { total: t, final: t - f }; }
    return { total: t, final: t - f };
  }
  function colorOf(k) { for (var i = 0; i < BASE.colors.length; i++) if (BASE.colors[i].k === k) return BASE.colors[i]; return null; }
  function famOk(f) { return f.keys.every(function (k) { return BY[k] && !BY[k].off; }); }
  function mzIcons(keys) {
    // la Mamá (o la más grande) en el centro y más grande; el resto a los lados
    return keys.map(function (k, i) { var d = BY[k], big = d.price >= 4500; return '<img src="' + d.src + '" alt="" width="' + (big ? 48 : 36) + '" height="' + (big ? 56 : 44) + '" class="' + (big ? 'is-big' : '') + '">'; }).join('');
  }
  function drawFams() {
    root.querySelectorAll('.cmp-mz-mount [data-mount]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-mount') === st.mount); });
    var box = root.querySelector('[data-mz-fams]');
    if (!box) return;
    var fams = MZ.fams.filter(famOk);
    box.hidden = !fams.length;
    // pulsera elástica (13-oct, Susana): tarjetas con foto real de la pulsera → 2 columnas
    box.classList.toggle('cmp-fams--ph', fams.some(function (f) { return f.img; }));
    box.innerHTML = fams.map(function (f) {
      var pr = famPrice(f.keys), top = !!f.top, mt = f.mount === 'sincolgar' ? 'Sin colgar' : f.mount ? 'Colgando' : '';
      if (f.img) {
        var cl = colorOf(f.color);
        // mismo formato que el collar (Susana): «Más vendido» arriba en la destacada; color y montaje debajo del nombre
        return '<button type="button" class="cmp-fam cmp-fam--ph' + (top ? ' cmp-fam--top' : '') + '" data-mz-fam="' + MZ.fams.indexOf(f) + '" aria-label="' + esc(f.name + (cl ? ', elástico ' + cl.name.toLowerCase() : '') + (mt ? ', ' + mt.toLowerCase() : '') + ', ' + eur(pr.final)) + '">' +
          (top ? '<span class="cmp-fam__badge">Más vendido</span>' : '') +
          '<img class="cmp-fam__foto" src="' + esc(f.img) + '" alt="" width="400" height="400" loading="lazy">' +
          '<b class="cmp-fam__n">' + esc(f.name) + '</b>' +
          (cl ? '<span class="cmp-fam__s cmp-fam__col"><i style="background:' + esc(cl.swatch) + '"></i>' + esc(cl.name) + (mt ? ' · ' + mt : '') + '</span>' : '') +
          '<span class="cmp-fam__p">' + (pr.final < pr.total ? '<s>' + eur(pr.total).replace(',00', '') + '</s> ' : '') + '<b>' + eur(pr.final).replace(',00', '') + '</b></span></button>';
      }
      return '<button type="button" class="cmp-fam' + (top ? ' cmp-fam--top' : '') + '" data-mz-fam="' + MZ.fams.indexOf(f) + '" aria-label="' + esc(f.name + ', ' + f.keys.length + ' patitos, ' + eur(pr.final)) + '">' +
        (top ? '<span class="cmp-fam__badge">Más vendido</span>' : '') +
        '<span class="cmp-fam__img' + (f.color ? ' is-pul' : '') + (f.keys.length === 1 ? ' is-solo' : '') + '">' + mzIcons(f.order || f.keys) + (f.color && colorOf(f.color) ? '<i class="cmp-fam__band" style="background:' + esc(colorOf(f.color).swatch) + '"></i>' : '') + '</span>' +
        '<b class="cmp-fam__n">' + esc(f.name) + '</b>' +
        // pulsera completa: el color del elástico con su muestra; si no, cuántos patitos lleva
        (f.color && colorOf(f.color) ? '<span class="cmp-fam__s cmp-fam__col"><i style="background:' + esc(colorOf(f.color).swatch) + '"></i>' + esc(colorOf(f.color).name) + '</span>'
          : '<span class="cmp-fam__s">' + f.keys.length + ' patito' + (f.keys.length > 1 ? 's' : '') + '</span>') +
        '<span class="cmp-fam__p">' + (pr.final < pr.total ? '<s>' + eur(pr.total).replace(',00', '') + '</s> ' : '') + '<b>' + eur(pr.final).replace(',00', '') + '</b></span></button>';
    }).join('');
  }
  // Cabecera de la mezcla dentro del paso de patitos: 3x2 + familias + «o elige patito a patito»
  function mzHead() {
    if (root.querySelector('.cmp-mz')) return;
    var h = document.createElement('div');
    h.className = 'cmp-mz';
    // 13-oct (Susana): el aviso del 3x2 va fuera del panel, debajo del precio (ver mzLayout)
    h.innerHTML = '<p class="cmp-mz__t">' + esc(MZ.famTitle || 'Los más elegidos') + '</p><div class="cmp-fams" data-mz-fams></div>' +
      // 13-oct (Susana): sin el selector «¿Cómo los quieres?»; el montaje lo pone la tarjeta (colgando / sin colgar)
      '<p class="cmp-mz__or"><span>' + esc(MZ.orText || 'o elige patito a patito') + '</span></p>';
    root.insertBefore(h, root.querySelector('.cmp-q') || anchor);
    drawFams();
  }
  // Orden de la ficha: patitos → nombres → cadena (opcional) → resumen
  function blockOf(n) { var s = q('[data-cm-step="' + n + '"]'); return s && (s.closest('.product-info__block-item') || s.parentNode); }
  function stepTxt(n, num, txt) { var s = q('[data-cm-step="' + n + '"]'); if (!s) return; var a = s.querySelector('.cm-step__n'), b = s.querySelector('span:not(.cm-step__n)'); if (a && a.textContent !== num) a.textContent = num; if (b && b.innerHTML !== txt) b.innerHTML = txt; }
  function mzLayout() {
    var b1 = blockOf(1), b3 = blockOf(3);
    if (b1 && b3 && b3.nextElementSibling !== b1) b3.parentNode.insertBefore(b1, b3.nextElementSibling);
    // 13-oct (Susana): los títulos de los pasos son los mismos que los de la barra de progreso
    stepTxt(2, '1', MZ_TIT[0]);
    stepTxt(3, '2', MZ_TIT[1]);
    stepTxt(1, '3', MZ_TIT[2]);
    stepTxt(4, '✓', 'Revisa y confirma');
    html.classList.add('cmp-mzon');
    // 13-oct (Susana): en escritorio, «Desde 30 €» y «Grabado gratis incluido en el precio» en una sola línea
    var pv = q('.product-info__block-item[data-block-id="price"] .v-stack'), pn = q('.product-info__block-item[data-block-id="price_note"] .cm-price-note');
    if (pv && pn && pn.parentNode !== pv) { pv.classList.add('cmp-mz-priceline'); pv.appendChild(pn); }
    // 13-oct (Susana): el 3x2 fuera del panel, justo debajo del precio
    var pb = q('.product-info__block-item[data-block-id="price"]');
    if (pb && !pb.querySelector('.cmp-mz__promo')) {
      var pr = document.createElement('p'); pr.className = 'cmp-mz__promo';
      pr.innerHTML = '<b>3x2</b><span>Con 3 patitos, el más barato es <strong>gratis</strong></span>';
      pb.appendChild(pr);
    }
    // 13-oct (Susana): la barra de pasos arriba, dentro del bloque beige (en móvil; en escritorio ya va encima del paso)
    // (la barra de pasos la pone mzD dentro del bloque del paso visible, en móvil y en escritorio)
    // 13-oct (Susana): sin el paso «Revisa y confirma», una línea con el total y el ahorro del 3x2 justo encima del botón
    if (b1 && !b1.querySelector('.cmp-mz-total')) { var tt = document.createElement('p'); tt.className = 'cmp-mz-total'; tt.hidden = true; b1.appendChild(tt); drawTotal(); }
  }
  function drawTotal() {
    var tt = q('.cmp-mz-total'); if (!tt) return;
    var n = st.items.length;
    tt.hidden = !n;
    if (!n) return;
    var pats = st.items.reduce(function (s, it) { return s + BY[it.k].price; }, 0), free = promo();
    var final = (st.noBase ? 0 : basePrice()) + pats - free + (MZ.caja && st.caja ? MZ.caja.price : 0);
    tt.innerHTML = '<span>Total <b>' + eur(final) + '</b></span>' +
      (free ? '<span class="cmp-mz-total__ok">ahorras ' + eur(free).replace(',00', '') + ' con el 3x2</span>'
        : n % 3 === 2 ? '<span class="cmp-mz-total__tip">añade 1 patito y te sale gratis (3x2)</span>' : '');
  }
  // Vista previa arriba (móvil): caja propia justo antes de la galería del tema
  function mzPlace() {
    var pg = q('product-gallery');
    if (!pg) { if (stage.parentNode !== root) root.insertBefore(stage, anchor); return; }
    if (!mzBox || !mzBox.isConnected) {
      mzBox = document.createElement('div'); mzBox.className = 'cmp-mztop';
      mzBox.innerHTML = '<button type="button" class="cmp-mztop__fotos" data-mz-fotos="1"><img src="' + esc(MZ.foto || '') + '" alt="" width="28" height="28">Fotos reales</button>';
    }
    if (pg.previousElementSibling !== mzBox) pg.parentNode.insertBefore(mzBox, pg);
    if (stage.parentNode !== mzBox) mzBox.appendChild(stage);
    if (!mzBack || !mzBack.isConnected) {
      mzBack = document.createElement('button'); mzBack.type = 'button'; mzBack.className = 'cmp-mzback'; mzBack.setAttribute('data-mz-fotos', '0');
      mzBack.textContent = 'Ver tu collar';
      pg.parentNode.insertBefore(mzBack, pg);
    }
    mzShow();
  }
  function mzShow() {
    var on = st.items.length > 0 && !deskActive();
    html.classList.toggle('cmp-mz-prev', on && !st.fotos);
    html.classList.toggle('cmp-mz-fotos', on && !!st.fotos);
  }
  // Paso en el que está la clienta (para la barra de progreso)
  function mzStep() { if (deskWiz()) return st.items.length ? st.dstep || 1 : 1; if (!st.items.length) return 1; if (st.run || !st.cad) return 2; return 3; }
  // nav = true (escritorio): cada tramo es un botón para ir a ese paso
  function progHtml(sub, nav) {
    // 13-oct (Susana): textos de la barra de progreso
    var s = mzStep(), lab = MZ_TIT, n0 = st.items.length;
    return '<div class="cmp-prog" aria-label="Paso ' + s + ' de 3">' + lab.map(function (l, i) {
      var n = i + 1, cls = n < s ? 'is-done' : n === s ? 'is-on' : '';
      var fill = n < s ? 100 : n === s && sub ? Math.round(sub[0] / sub[1] * 100) : n === s ? 100 : 0;
      // 13-oct (Susana): que se vea claro en la propia barra en qué paso estás → número en círculo (✓ si ya está hecho) y el paso en curso resaltado
      var inner = '<i><b style="width:' + fill + '%"></b></i><span><em class="cmp-prog__n" aria-hidden="true">' + (n < s ? '✓' : n) + '</em><strong class="cmp-prog__l">' + l + (n === s && sub ? '<em class="cmp-prog__sub"> · ' + sub[0] + '/' + sub[1] + '</em>' : '') + '</strong></span>';
      return nav ? '<button type="button" class="cmp-prog__s ' + cls + '" data-mz-dstep="' + n + '"' + (n > 1 && !n0 ? ' disabled' : '') + (n === s ? ' aria-current="step"' : '') + '>' + inner + '</button>'
        : '<div class="cmp-prog__s ' + cls + '">' + inner + '</div>';
    }).join('') + '</div>';
  }
  // ---------- Escritorio (13-oct, Susana): los pasos van saliendo de uno en uno en la misma zona del panel
  // 13-oct (Susana): «aplica todos los cambios de desktop a móvil» → los pasos secuenciales en el panel valen para todos los anchos
  function deskWiz() { return !!MZ; }
  // orden en que se piden los nombres: primero los grandes (Mamá, Papá, Abuela…), luego el resto en el orden del collar
  function allRun() { return st.items.map(function (x, i) { return i; }).sort(function (a, b) { return BY[st.items[b].k].price - BY[st.items[a].k].price || a - b; }); }
  function mzD(step) {
    if (!deskWiz()) { html.classList.remove('cmp-mzd'); return; }
    if (step) st.dstep = step;
    if (!st.items.length) st.dstep = 1;
    st.dstep = st.dstep || 1;
    html.classList.add('cmp-mzd');
    html.setAttribute('data-mzd', st.dstep);
    // la barra va DENTRO del bloque beige del paso que se ve (1 = patitos, 2 = nombres, 3 = cadena), arriba del todo
    var bk = blockOf([0, 2, 3, 1][st.dstep]), dp = q('.cmp-mz-dprog');
    if (bk && (!dp || dp.parentNode !== bk || bk.firstChild !== dp)) { if (!dp) { dp = document.createElement('div'); dp.className = 'cmp-mz-dprog'; } bk.insertBefore(dp, bk.firstChild); }
    if (dp) dp.innerHTML = progHtml(st.dstep === 2 && st.run && st.run.length > 1 ? [st.runPos + 1, st.run.length] : null, true);
    var nx = root.querySelector('.cmp-mz-dnext');
    if (!nx) { nx = document.createElement('button'); nx.type = 'button'; nx.className = 'cmp-mz-dnext'; nx.setAttribute('data-mz-dstep', '2'); nx.textContent = 'Siguiente: sus nombres'; root.appendChild(nx); }
    nx.hidden = !st.items.length;
  }
  // al cambiar de paso, el bloque queda arriba a la vista (con margen para la cabecera fija del tema)
  function dTop() {
    var dp = q('.cmp-mz-dprog'); if (!dp) return;
    var t = dp.getBoundingClientRect().top;
    if (t < 70 || t > window.innerHeight * 0.55) window.scrollTo({ top: t + window.scrollY - 90, behavior: 'smooth' });
  }
  function mzBar(bar, n) {
    var p = bar.querySelector(':scope > .cmp-prog-wrap');
    if (!p) { p = document.createElement('div'); p.className = 'cmp-prog-wrap'; bar.insertBefore(p, bar.firstChild); }
    p.innerHTML = progHtml();
    // botón fijo: «Siguiente» hasta llegar al paso 3; luego vuelve a su texto («Añadir a la cesta»)
    var sb = bar.querySelector('buy-buttons button[type="submit"]');
    if (sb) {
      if (!sb.getAttribute('data-cmp-txt')) sb.setAttribute('data-cmp-txt', sb.textContent.trim());
      var want = n && (st.dstep || 1) < 3 ? 'Siguiente' : sb.getAttribute('data-cmp-txt');
      if (sb.textContent.trim() !== want) sb.textContent = want;
    }
  }
  // ---------- Hoja de nombres
  function backSvg(k, txt) {
    var b = BACKS[k], d = BY[k];
    if (!b) return '<div class="cmp-sh__front"><img src="' + d.src + '" alt="" width="160" height="132"></div>';
    var iw = b[3] || 1000, src = CDN + 'files/' + b[1] + '?v=' + (b[2] || 1789664000), ls = lines2(txt), size = b[7];
    // encuadre cerrado alrededor del patito (la zona del grabado mide w y está en la tripa): 2,5 w de ancho, de la cabeza a la base
    var w = b[6], vb = (b[9] || [b[4] - 1.25 * w, b[5] - 2.8 * w, 2.5 * w, 3.4 * w]).map(function (x) { return Math.round(x); }).join(' ');
    var t = ls.map(function (l, i) { var dy = (i - (ls.length - 1) / 2) * size * 1.15; return '<text x="' + b[4] + '" y="' + (b[5] + dy) + '" data-w="' + b[6] + '" font-size="' + size + '" fill="' + (b[8] || '#50555c') + '">' + esc(l) + '</text>'; }).join('');
    return '<svg class="cmp-sh__svg" viewBox="' + vb + '" role="img" aria-label="Parte de atrás de ' + esc(d.name) + (ls.length ? ' con «' + esc(ls.join(' ')) + '» grabado' : '') + '"><image href="' + src + '" width="' + iw + '" height="' + iw + '"/>' + t + '</svg>';
  }
  // el texto no puede pasarse de la zona medida (w): si es más ancho se reduce, como en la ficha de cada colgante
  function fitText() {
    document.querySelectorAll('.cmp-sh__svg text').forEach(function (t) {
      var w = +t.getAttribute('data-w'), fs = +t.getAttribute('font-size');
      try { var bw = t.getBBox().width; if (bw > w) t.setAttribute('font-size', (fs * w / bw).toFixed(1)); } catch (e) {}
    });
  }
  function mzOpen(run, fam) {
    if (!run.length) return;
    st.run = run; st.runPos = 0; st.runFam = fam || '';
    st.focus = run[0];
    if (deskWiz()) {
      // escritorio: la «hoja» se pinta dentro del panel, en el paso 2, en lugar de los patitos
      var b3 = blockOf(3), host = q('.cmp-mz-dhost');
      if (b3 && !host) { host = document.createElement('div'); host.className = 'cmp-mz-dhost'; b3.appendChild(host); }
      mzD(2); drawSvg(); drawGuide(); mzDraw(); dTop();
      return;
    }
    if (!mzSheet) {
      mzSheet = document.createElement('div'); mzSheet.className = 'cmp-sh'; mzSheet.hidden = true;
      mzSheet.innerHTML = '<div class="cmp-sh__bg" data-mz-close></div><div class="cmp-sh__p" role="dialog" aria-modal="true" aria-labelledby="cmp-sh-t" data-mz-panel></div>';
      document.body.appendChild(mzSheet);
    }
    mzSheet.hidden = false;
    html.classList.add('cmp-sh-open');
    mzShow(); drawSvg(); drawGuide(); mzDraw();
  }
  function mzClose() {
    st.run = null; st.focus = -1;
    if (mzSheet) mzSheet.hidden = true;
    html.classList.remove('cmp-sh-open');
    drawSvg(); drawEngr(); drawGuide();
  }
  function mzDraw() {
    var dk = deskWiz(), p = dk ? q('.cmp-mz-dhost') : mzSheet.querySelector('[data-mz-panel]'), run = st.run, pos = st.runPos, k = run[pos], it = st.items[k];
    if (!it || !p) { mzClose(); return; }
    var d = BY[it.k], fr = freeIdx(), many = run.length > 1, last = pos === run.length - 1, n = st.items.length;
    var famTxt = st.runFam ? (function () { var f = MZ.fams[+st.runFam], pr = famPrice(f.keys); return esc(f.name) + ' · <b>' + eur(pr.final).replace(',00', '') + (pr.final < pr.total ? ' con 3x2' : '') + '</b>'; })() : esc(d.name) + ' · ' + eur(d.price).replace(',00', '');
    var thumbs = many ? '<div class="cmp-sh__th">' + run.map(function (kk, i) {
      var ii = st.items[kk], dd = BY[ii.k], done = i < pos;
      return '<button type="button" class="cmp-sh__t' + (i === pos ? ' is-on' : '') + '" data-mz-go="' + i + '" aria-label="' + esc(dd.name) + (grab(ii) ? ': ' + esc(grab(ii)) : '') + '">' + (fr[kk] ? '<em>Gratis</em>' : '') + '<img src="' + dd.src + '" alt="" width="28" height="30">' + (done ? '<i aria-hidden="true">✓</i>' : '') + '</button>';
    }).join('') + '</div>' : '';
    var more = n < CFG.max ? '<button type="button" class="cmp-sh__b2" data-mz-more>+ Otro patito' + (n % 3 === 2 ? ' <small>¡te sale gratis!</small>' : '') + '</button>' : '';
    p.innerHTML = (dk ? '' : '<div class="cmp-sh__grip" aria-hidden="true"></div>' +
      '<button type="button" class="cmp-sh__x" data-mz-close aria-label="Cerrar">✕</button>' +
      progHtml(many ? [pos + 1, run.length] : null)) +
      '<div class="cmp-sh__head"><div><small>' + famTxt + '</small><b id="cmp-sh-t">' + esc(d.name) + ' <button type="button" class="cmp-sh__rm" data-rm="' + k + '" aria-label="Quitar ' + esc(d.name) + '">Quitar</button></b></div>' + thumbs + '</div>' +
      '<div class="cmp-sh__back"><div data-mz-back>' + backSvg(it.k, it.none ? '' : it.txt) + '</div><p>' + (fr[k] ? '<b>Este te sale gratis</b> con el 3x2.' : 'Así queda por detrás. Cambia mientras escribes.') + '</p></div>' +
      '<label class="cmp-sh__l" for="cmp-sg">' + (pos === 0 ? '¿Qué nombre le grabamos?' : '¿Y ' + (/^(Mamá|Patita|Abuela)/.test(d.name) ? 'a la ' : 'al ') + esc(d.name.toLowerCase()) + '?') + '</label>' +
      '<textarea id="cmp-sg" data-sg="' + k + '" rows="1" autocomplete="off" autocapitalize="sentences" spellcheck="false" placeholder="Nombre o fecha">' + esc(it.none ? '' : it.txt || '') + '</textarea>' +
      '<div class="cmp-sh__sym"><button type="button" class="cmp-sym" data-msym="♥" aria-label="Añadir corazón">♥</button><button type="button" class="cmp-sym" data-msym="∞" aria-label="Añadir infinito">∞</button><span>Gratis · opcional · 2 líneas máx.</span></div>' +
      '<div class="cmp-sh__btns">' + (last
        ? more + '<button type="button" class="cmp-sh__b1" data-mz-done>Listo, elegir ' + (MZ.colorTitle ? 'color' : 'cadena') + '</button>'
        : '<button type="button" class="cmp-sh__skip" data-mz-next="skip">Sin nombre</button><button type="button" class="cmp-sh__b1" data-mz-next="1">Siguiente: ' + esc(BY[st.items[run[pos + 1]].k].name) + '</button>') + '</div>' +
      // 13-oct (Susana): quien no quiere grabar pasa al paso 3 de un toque (no a la cesta: así ve la cadena y la caja nido)
      '<button type="button" class="cmp-sh__noengr" data-mz-noengr>Continuar sin grabar →</button>';
    fitText();
    if (document.fonts && document.fonts.load) document.fonts.load('27px cmpGrab').then(fitText).catch(function () {});
    if (dk) mzD();
  }
  function mzBackOnly() { var b = q('[data-mz-back]'), it = st.run && st.items[st.run[st.runPos]]; if (b && it) { b.innerHTML = backSvg(it.k, it.txt); fitText(); } }
  function mzGo(i) { st.runPos = Math.max(0, Math.min(st.run.length - 1, i)); st.focus = st.run[st.runPos]; drawSvg(); mzDraw(); }
  function toCadena() {
    st.cad = true; mzClose();
    if (deskWiz()) { mzD(3); drawGuide(); dTop(); return; }
    var b1 = q('[data-cm-step="1"]'); if (b1) b1.scrollIntoView({ block: 'start', behavior: 'smooth' });
    drawGuide();
  }
  document.addEventListener('click', function (ev) {
    if (!MZ) return;
    var b = ev.target.closest && ev.target.closest('[data-mz-fam],[data-mz-close],[data-mz-next],[data-mz-go],[data-mz-more],[data-mz-done],[data-mz-fotos],[data-msym],[data-mz-dstep],[data-mz-noengr]');
    if (!b) return;
    var ds = b.dataset;
    if (ds.mzFam !== undefined) {
      var f = MZ.fams[+ds.mzFam]; if (!f) return;
      // la familia se cuelga en el orden de la foto (Mamá en el centro); los nombres se piden empezando por la Mamá
      var order = f.order || f.keys;
      // pulsera completa: trae su color de elástico y va «Colgando»
      if (f.color && colorOf(f.color)) { st.color = f.color; st.noBase = false; }
      var fm = f.mount || 'colgando';
      if (MOUNT && st.mount !== fm) { st.mount = fm; applyMount(); drawCats(); }
      st.items = order.map(function (kk) { return { k: kk, txt: '' }; });
      st.fotos = false;
      all(); track('familia', { familia: f.keys.join(','), n: st.items.length });
      // nombres empezando por los grandes; allRun() también vale si la familia repite patito (Mamá y 2 patitos)
      var run = allRun();
      mzOpen(run, String(+ds.mzFam));
    }
    else if (ds.mzClose !== undefined) mzClose();
    else if (ds.mzNext) {
      if (ds.mzNext === 'skip') { var it0 = st.items[st.run[st.runPos]]; if (it0) it0.txt = ''; }
      mzGo(st.runPos + 1);
    }
    else if (ds.mzGo !== undefined) mzGo(+ds.mzGo);
    else if (ds.mzMore !== undefined) { mzClose(); if (deskWiz()) { mzD(1); dTop(); return; } var c = root.querySelector('.cmp-mz__or') || anchor; c.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    else if (ds.mzDstep) {
      // escritorio: ir a un paso desde la barra de progreso o «Siguiente: sus nombres»
      var s = +ds.mzDstep;
      if (s > 1 && !st.items.length) return;
      if (s === 2) { mzOpen(allRun(), ''); return; }
      st.run = null; st.focus = -1;
      if (s === 3) st.cad = true;
      mzD(s); drawSvg(); drawGuide(); dTop();
    }
    else if (ds.mzDone !== undefined) toCadena();
    else if (ds.mzNoengr !== undefined) {
      // los patitos que aún no tienen nombre van «Sin grabado»; los nombres ya escritos se respetan
      st.items.forEach(function (it) { if (!lines2(it.txt).length) { it.txt = ''; it.none = true; } });
      track('sin_grabado_atajo', { n: st.items.length });
      toCadena();
    }
    else if (ds.mzFotos) { st.fotos = ds.mzFotos === '1'; mzShow(); var top = q('.cmp-mztop') || q('product-gallery'); if (top) top.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    else if (ds.msym) {
      var t = q('[data-sg]'); if (!t) return;
      var v = t.value, p0 = t.selectionStart == null ? v.length : t.selectionStart, p1 = t.selectionEnd == null ? v.length : t.selectionEnd;
      t.value = clean(v.slice(0, p0) + ds.msym + v.slice(p1));
      t.focus(); try { t.setSelectionRange(p0 + 1, p0 + 1); } catch (e) {}
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });
  if (MZ) {
    document.addEventListener('mousedown', function (ev) { if (ev.target.closest && ev.target.closest('[data-msym]')) ev.preventDefault(); });
    document.addEventListener('input', function (ev) {
      var t = ev.target; if (!t.dataset || t.dataset.sg === undefined) return;
      var c = clean(t.value);
      if (c !== t.value) { var p0 = t.selectionStart; t.value = c; try { t.setSelectionRange(Math.min(p0, c.length), Math.min(p0, c.length)); } catch (e) {} }
      var it = st.items[+t.dataset.sg]; if (!it) return;
      it.txt = c; it.none = false;
      mzBackOnly(); drawGuide();
    });
    document.addEventListener('change', function (ev) {
      var t = ev.target; if (!t.hasAttribute || !t.hasAttribute('data-mz-caja')) return;
      st.caja = t.checked; drawGuide(); track('caja_nido', { on: st.caja });
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && st.run && !deskWiz()) mzClose(); });
    // al llegar al paso de la cadena haciendo scroll, la barra de progreso pasa al paso 3
    window.addEventListener('scroll', function () {
      if (st.cad || !st.items.length || st.run) return;
      var s1 = q('[data-cm-step="1"]'); if (!s1) return;
      var r = s1.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.6 && r.bottom > 0) { st.cad = true; drawGuide(); }
    }, { passive: true });
    // la hoja es la que pide los nombres: el paso 3 antiguo no se abre solo
    st.engrOpen = st.items.length > 0;
    st.fotos = false;
    // «Mejora tu compra» (caja nido) pasa al paso de la cadena: el bloque del tema se oculta para no sacar a la clienta de la ficha
    html.classList.add('cmp-mz-nocomp');
    mzHead();
    mzLayout();
  }
  searchBox();

  if (noun() === 'Pulsera') stage.classList.add('cmp-fade');
  var hint = root.querySelector('.cm-p__hint'); if (hint) hint.textContent = 'Hasta ' + CFG.max + ' patitos. Se colocan de izquierda a derecha en el orden en que los añades.';
  placeStage();
  applyMount();
  drawCats();
  all();
  arrows();
  setTimeout(arrows, 800);
  barCheck();
  if (mqDesk && mqDesk.addEventListener) mqDesk.addEventListener('change', function () { placeStage(); drawGuide(); });
  // El tema re-renderiza partes de la ficha: recolocamos la vista previa y repintamos pasos si hace falta
  setInterval(function () {
    var grid = q('product-gallery .product-gallery__image-list');
    if (deskActive() && grid && (!stage.isConnected || grid.firstChild !== stage.parentNode)) placeStage();
    if (MZ && !deskActive() && (!mzBox || !mzBox.isConnected || stage.parentNode !== mzBox)) placeStage();
    if (MZ) { mzLayout(); if (!root.querySelector('.cmp-mz')) mzHead(); }
    if (!root.querySelector('[data-cmp-q]')) searchBox();
    var colors = q('[data-cmp-colors]'); if (colors && !colors.innerHTML.trim()) drawColor();
    var eng = q('[data-cmp-engr]'); if (eng && !eng.innerHTML.trim()) drawEngr();
    var res = q('[data-cm-resumen]'); if (res && !res.innerHTML.trim()) drawGuide();
    barCheck(); // por si el navegador no avisa del scroll (p. ej. al volver a la pestaña)
  }, 700);
})();
